import { EmptyView } from '@components'

import { ReactElement, useCallback } from 'react'
import { useNavigate } from 'react-router'

import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { bankTransactionsEmptyStateConfig } from './consts/bankTransactionsEmptyStateConfig'
import { BankTransactionsEmptyStateVariant } from './enums/bankTransactionsEmptyStateVariant'

interface BankTransactionsEmptyStateProps {
  variant: BankTransactionsEmptyStateVariant
}

export const BankTransactionsEmptyState = ({ variant }: BankTransactionsEmptyStateProps): ReactElement | null => {
  const navigate = useNavigate()
  const { url: bankAccountsUrl } = useOrganizationViewUrl(reactRoute.organization.bank.getBankAccountsRoute())

  const handleBankAccountsNavigationClick = useCallback(() => {
    if (bankAccountsUrl) {
      navigate(bankAccountsUrl)
    }
  }, [bankAccountsUrl, navigate])

  const { illustration, titleKey, descriptionKey, buttonTextKey, buttonIcon, showCTA } =
    bankTransactionsEmptyStateConfig[variant]

  return (
    <EmptyView
      illustration={illustration}
      tTitle={titleKey}
      tDescription={descriptionKey}
      {...(showCTA && {
        onClick: handleBankAccountsNavigationClick,
        showCTA: true,
        tButton: buttonTextKey,
        buttonIcon,
      })}
    />
  )
}
